import React, { FC } from 'react';
import { Path } from './styles';

const Cheff: FC<SVGIconProps> = ({ color }) => (
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none">
    <Path
      d="M32.8125 3.9375C28.1663 3.9375 24.0713 7.00875 22.7588 11.4712C21.3675 10.8412 19.8975 10.5 18.375 10.5C15.5902 10.5 12.9195 11.6062 10.9504 13.5754C8.98125 15.5445 7.875 18.2152 7.875 21C7.875 25.7775 11.13 29.9512 15.75 31.1587V49.875H49.875V31.1587C54.495 29.9512 57.75 25.7775 57.75 21C57.75 18.2152 56.6438 15.5445 54.6746 13.5754C52.7055 11.6062 50.0348 10.5 47.25 10.5C45.7275 10.5 44.2575 10.8412 42.8662 11.4712C41.5537 7.00875 37.4587 3.9375 32.8125 3.9375ZM31.5 27.5625H34.125V45.9375H31.5V27.5625ZM23.625 32.8125H26.25V45.9375H23.625V32.8125ZM39.375 32.8125H42V45.9375H39.375V32.8125ZM15.75 52.5V55.125C15.75 55.8212 16.0266 56.4889 16.5188 56.9812C17.0111 57.4734 17.6788 57.75 18.375 57.75H47.25C47.9462 57.75 48.6139 57.4734 49.1062 56.9812C49.5984 56.4889 49.875 55.8212 49.875 55.125V52.5H15.75Z"
      fillColor={color}
    />
  </svg>
);

export default Cheff;
